import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeviceMaintenanceComponent } from './components/maintenance.component';
import { AuthGuard } from '../core/auth.guard';


const routes: Routes = [
  {
    path: 'device/maintenance',
    component: DeviceMaintenanceComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeviceRoutingModule { }
